import { useEffect } from 'react';
import { RequestState } from '../../constants/request-state';
import { isRequestNone } from '../../utils';
import { loanService } from '../../services/loan.service';
import { loanFieldValuesActions } from '../../actions/entities/loanFieldValues.actions';
import { useAppDispatch } from '../useAppDispatch';
import { useAppSelector } from '../useAppSelector';

export function useLoanFieldValues() {
    const dispatch = useAppDispatch();
    const { requestState, values } = useAppSelector(s => s.entities.loanFieldValues);

    useEffect(() => {
        if (isRequestNone(requestState)) {
            const doRequest = async () => {
                dispatch(loanFieldValuesActions.request(RequestState.request));
                try {
                    const result = await loanService.getLoanFieldValues();
                    dispatch(loanFieldValuesActions.response(RequestState.success, result));
                } catch (e) {
                    dispatch(loanFieldValuesActions.request(RequestState.failure));
                }
            };

            doRequest();
        }
    }, [requestState, dispatch]);

    return { requestState, values };
}
